import React, { useEffect, useState } from "react";
import $ from 'jquery';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_URL;

    let table = $('#settings').DataTable({
      "destroy": true,
      "ajax": {
        url: `${baseUrl}settings`,
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.post('/logout')
              .then(res => {
                localStorage.removeItem('persist:root');
                navigate('/login');
              });
          }
        }
      },
      "columns": [
        { data: 'id', name: 'id' },
        { data: 'key', name: 'key', searchable: true },
        {
          data: 'actions',
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            return `<button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-1 mt-1 edit"
                            row-id="${row.id}">
                                <i class="fas fa-edit"></i> Edit
                            </button>
                        <div>
                    </div>`;
          },
        }
      ],
      "order": [[0, "desc"]],
    });

    table.off('click');

    table.on('click', 'button.actions', function () {
      $(this).next(".row-actions").fadeToggle(200).toggleClass("hidden-actions")
    });

    table.on('click', 'button.edit', function () {
      const id = $(this).attr("row-id");
      navigate(`/general-settings/${id}/edit`);
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");
  }, []);


  return (<>
    <div>
      <div className="d-flex flex-stack mb-5">
      </div>
      <table id="settings" className="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
        <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
          <th>ID</th>
          <th>Key</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody className="text-gray-600 fw-bold">
        </tbody>
      </table>
    </div>
  </>);
}